export default __webpack_public_path__ + "static/media/chat-new.09c9e1df.svg";